const config = {
  aws: {
    region: process.env.REACT_APP_AWS_REGION || "ap-south-1",
    credentials: {
      accessKeyId: null,
      secretAccessKey: null,
    },
  },
};

export const initializeConfig = async () => {
  try {
    const response = await fetch(
      "https://procbackend.elcarreira.com/resManage/keys/getKeys?service=kinesis"
    );
    if (!response.ok) {
      throw new Error("Failed to fetch AWS credentials");
    }
    const data = await response.json();

    config.aws.credentials.accessKeyId = data.id;
    config.aws.credentials.secretAccessKey = data.secret;

    console.log("AWS Credentials fetched successfully:", {
      accessKeyId: data.id,
      secretAccessKey: data.secret,
      region: config.aws.region,
    });

    return config;
  } catch (error) {
    console.error("Error fetching AWS credentials:", error);
    throw error;
  }
};

export default config;
